import type { StepConfigParams } from '@flows/configs/types'

export const formatClaimSublimit = (
  value: string | undefined,
  params: StepConfigParams
): string => {
  if (!value) {
    return ''
  }
  const numericValue = Number(value)
  return Number.isNaN(numericValue)
    ? value
    : params.clientHelpers.formatter.formatCurrency(numericValue)
}
